import React from "react";
import { Box, styled } from "@mui/material";

import SortArrow from "../../../../components/ui/SortArrow";
import { useDiscountsContext } from "../../../../context";
import newSortBy from "../../../../utils/newSortBy";

const TdData = styled(Box)({ display: "flex", color: "white" });

const TableHeader = (): React.ReactElement => {
  const { sortBy, setSortBy, columns } = useDiscountsContext();
  const handleSortBy = (by: string) => newSortBy({ by, sortBy, setSortBy });

  return (
    <thead>
      <tr>
        {sortBy.by !== "id" && (
          <td className="canSort" style={{ textAlign: "right" }}>
            <div onClick={() => handleSortBy("id")} role="button" tabIndex={-1}>
              R
            </div>
          </td>
        )}

        <td style={{ textAlign: "center" }}>
          <TdData>#</TdData>
        </td>

        {columns.includes("code") && (
          <td className="canSort" style={{ textAlign: columns.length <= 2 ? "center" : "right" }}>
            <TdData onClick={() => handleSortBy("code")} role="button" tabIndex={-1}>
              <SortArrow sortBy={sortBy} by="code" invert />
              Code
            </TdData>
          </td>
        )}

        {columns.includes("description") && (
          <td className="canSort">
            <TdData onClick={() => handleSortBy("description")} role="button" tabIndex={-1}>
              Description
              <SortArrow sortBy={sortBy} by="description" invert />
            </TdData>
          </td>
        )}

        {columns.includes("user") && (
          <td>
            <TdData>
              User
              <SortArrow sortBy={sortBy} by="user" invert />
            </TdData>
          </td>
        )}

        {columns.includes("discount") && <td style={{ textAlign: "right" }}>Discount</td>}

        {columns.includes("discount_past_expiration") && (
          <td style={{ textAlign: "right" }}>Discount (Past Expiration)</td>
        )}

        {columns.includes("type") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData onClick={() => handleSortBy("type")} role="button" tabIndex={-1}>
              Type
              <SortArrow sortBy={sortBy} by="type" invert />
            </TdData>
          </td>
        )}

        {columns.includes("price") && <td>Price</td>}

        {columns.includes("plan") && <td>Plan</td>}

        {columns.includes("used") && <td>Used</td>}

        <td className="canSort" style={{ textAlign: "center" }}>
          <TdData onClick={() => handleSortBy("code_count")} tabIndex={-1} role="button">
            Quantity
            <SortArrow sortBy={sortBy} by="code_count" invert />
          </TdData>
        </td>

        {columns.includes("active") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData
              className="canSort"
              onClick={() => handleSortBy("active")}
              role="button"
              tabIndex={-1}
            >
              Active
              <SortArrow sortBy={sortBy} by="active" invert />
            </TdData>
          </td>
        )}

        {columns.includes("expires") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData onClick={() => handleSortBy("expires")} tabIndex={-1} role="button">
              Expires
              <SortArrow sortBy={sortBy} by="expires" invert />
            </TdData>
          </td>
        )}

        {columns.includes("expiration") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData
              className="canSort"
              onClick={() => handleSortBy("expiration")}
              role="button"
              tabIndex={-1}
            >
              Discount Duration / Termination Date
              <SortArrow sortBy={sortBy} by="expiration" invert />
            </TdData>
          </td>
        )}

        {columns.includes("fixed_reset") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData
              className="canSort"
              onClick={() => handleSortBy("fixed_reset")}
              role="button"
              tabIndex={-1}
            >
              Fixed reset
              <SortArrow sortBy={sortBy} by="expiration" invert />
            </TdData>
          </td>
        )}

        {columns.includes("lifetime") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData onClick={() => handleSortBy("one_time")} tabIndex={-1} role="button">
              Lifetime
              <SortArrow sortBy={sortBy} by="one_time" invert />
            </TdData>
          </td>
        )}

        {columns.includes("accepted") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData
              className="canSort"
              role="button"
              tabIndex={-1}
              onClick={() => handleSortBy("accepted")}
            >
              Accepted
              <SortArrow sortBy={sortBy} by="accepted" invert />
            </TdData>
          </td>
        )}

        {columns.includes("createdBy") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData
              className="canSort"
              role="button"
              tabIndex={-1}
              onClick={() => handleSortBy("ac.createdBy")}
            >
              Created by
              <SortArrow sortBy={sortBy} by="ac.createdBy" invert />
            </TdData>
          </td>
        )}
        {columns.includes("created") && (
          <td className="canSort" style={{ textAlign: "center" }}>
            <TdData
              className="canSort"
              role="button"
              tabIndex={-1}
              onClick={() => handleSortBy("created")}
            >
              Created
              <SortArrow sortBy={sortBy} by="created" invert />
            </TdData>
          </td>
        )}
      </tr>
    </thead>
  );
};

export default TableHeader;
